import { Inject, Injectable } from '@angular/core';
import { LOG_ROCKET_CONFIGURATION, LogRocketConfiguration, isNullOrUndefined } from '@uzurv/core';
import { AuthDataService } from '@uzurv/http';
import LogRocket from 'logrocket';
import { Subject, takeUntil } from 'rxjs';
import { APP_CONFIGURATION, AppConfiguration } from '../../app/app-configuration';

@Injectable({
  providedIn: 'root'
})
export class LogRocketService {
  private destroyed$ = new Subject<void>();

  constructor(
    private authDataService: AuthDataService,
    @Inject(APP_CONFIGURATION) private appConfiguration: AppConfiguration,
    @Inject(LOG_ROCKET_CONFIGURATION) protected logRocketConfiguration: LogRocketConfiguration
  ) {}

  init() {
    if (this.logRocketConfiguration.logRocketSessionCaptureEnabled) {
      LogRocket.init(this.logRocketConfiguration.logRocketProjectKey, {
        release: this.appConfiguration.version,
        network: {
          requestSanitizer: request => {
            // scrub out the body
            if (this.shouldSanitizeRequestBody(request.url, request.method)) {
              request.body = null;
            }

            return request;
          },
          responseSanitizer: response => {
            const errors = response.body['errors'];

            // Scrub response body unless there are errors
            if (isNullOrUndefined(errors) || errors.length === 0) {
              delete response.body;
            }

            return response;
          }
        }
      });
    }

    if (this.authDataService.isLoggedIn) {
      this.identifyAuthenticatedUser();
    }

    this.authDataService.loggedInUserDataStoredEvents.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      if (this.authDataService.isLoggedIn) {
        this.identifyAuthenticatedUser();
      }
    });

    this.authDataService.logoutEvents.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      LogRocket.identify(null, null);
    });
  }

  private identifyAuthenticatedUser() {
    if (isNullOrUndefined(this.authDataService.currentUser)) {
      LogRocket.identify(null, null);
    } else {
      LogRocket.identify(this.authDataService.currentUser.claraPersonId.toString(), {
        name: `${this.authDataService.currentUser.firstName} ${this.authDataService.currentUser.lastName}`,
        email: this.authDataService.currentUser.username
      });
    }
  }

  private shouldSanitizeRequestBody(requestUrl: string, requestMethod: string): boolean {
    return true;
  }
}
